import CodebookValueNotFoundError from '../CodebookValueNotFoundError'
import { TranslatableNameCodebook } from '../TranslatableNameCodebook'
import { $t } from '../../composables/i18n'

export enum CompanyTypeId {
  TRAVEL_AGENCY = 1,
  AGENCY = 2,
  OTHER = 3,
  OWNER = 4,
}

export class CompanyType extends TranslatableNameCodebook {
  static readonly TRAVEL_AGENCY = new CompanyType(CompanyTypeId.TRAVEL_AGENCY, $t('Travel agency'))
  static readonly AGENCY = new CompanyType(CompanyTypeId.AGENCY, $t('Agency'))
  static readonly OTHER = new CompanyType(CompanyTypeId.OTHER, $t('Other (companies, ...)'))
  static readonly OWNER = new CompanyType(CompanyTypeId.OWNER, $t('Owner'))

  private constructor(
    public readonly id: CompanyTypeId,
    name: string,
  ) {
    super(name)
  }

  static getById = (id: CompanyTypeId): CompanyType => {
    const value = CompanyType.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(CompanyType.name, id)
    }

    return value
  }

  static all = (): CompanyType[] => {
    return [
      CompanyType.TRAVEL_AGENCY, // Keep each item on new line
      CompanyType.AGENCY,
      CompanyType.OTHER,
      CompanyType.OWNER,
    ]
  }
}
